import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import FormInput from 'components/Input/FormInput';
import Text from 'components/Text/Text';
import style from './ModifierGroup.module.scss';

interface IProps {
	changeDownLimit: (id: string, value: Nullable<number>) => void;
	changeUpLimit: (id: string, value: Nullable<number>) => void;
	onDelete: (id: string) => void;
	positionNumber: number;
	label: string;
	modifierGroupId: string;
	inclusive: Nullable<number>;
}

export const ModifierGroup: React.FC<IProps> = React.memo(
	({ changeDownLimit, changeUpLimit, onDelete, positionNumber, label, modifierGroupId, inclusive }) => {
		const handleRemove = () => {
			onDelete(modifierGroupId);
		};

		const handleChangeDownLimit = (value: Nullable<number>) => {
			changeDownLimit(modifierGroupId, value);
		};

		const handleChangeUpLimit = (value: Nullable<number>) => {
			changeUpLimit(modifierGroupId, value);
		};

		return (
			<div className={style.container}>
				<div className={style.content}>
					<div className={style.header}>
						<div className={style.labelRow}>
							<Text
								className={style.positionNumber}
								translationNameSpace="form"
								translationKey="positionNumberLabel"
								translationOptions={{ positionNumber }}
								theme="secondary"
								size="s"
								weight="bold"
							/>
							<Text
								className={style.labelText}
								translationKey={label}
								theme="secondary"
								size="xs"
								withTooltip={true}
							/>
							<div />
						</div>
						<div className={style.itemAdditionalInfoDeleteBtnWrapper}>
							<div className={style.itemAdditionalInfo}>
								<Text
									translationNameSpace="form"
									translationKey="inclusiveLabel"
									theme="neutralLight"
									size="xs"
								/>
								<Text
									translationKey={typeof inclusive === 'number' ? String(inclusive) : '-'}
									size="xs"
								/>
							</div>
							<div className={style.deleteBtn} onClick={handleRemove}>
								<svg className={style.icon}>
									<use xlinkHref={`${breadcrumbs}#bin`} />
								</svg>
							</div>
						</div>
					</div>
					<div className={style.limits}>
						<FormInput
							testId="LowerLimitField"
							name={`downLimit-${modifierGroupId}`}
							label="lowerLimitLabel"
							min={0}
							precision={0}
							onChangeNumber={handleChangeDownLimit}
							type="number"
						/>
						<FormInput
							testId="UpperLimitField"
							name={`upLimit-${modifierGroupId}`}
							label="upperLimitLabel"
							min={0}
							precision={0}
							onChangeNumber={handleChangeUpLimit}
							type="number"
						/>
					</div>
				</div>
			</div>
		);
	},
);
